import { Marquee, type MarqueeDirection } from '@natu/ui/Marquee';

import { type BlokItem, type SBProps, DynamicRender, sbEditable } from '../../../../utils';

interface SBMarqueeProps {
  body?: BlokItem[];
  direction?: MarqueeDirection;
  transition?: string;
}

export const SBMarquee = ({ blok }: SBProps<SBMarqueeProps>) => {
  const { body, direction, transition } = blok;

  const transitionDuration = transition && parseInt(transition, 10);

  return (
    <Marquee
      className="gap-4 pb-2"
      direction={direction}
      transition={Number(transitionDuration)}
      {...sbEditable(blok)}
    >
      <div className="flex items-center gap-4 whitespace-nowrap">
        <DynamicRender data={body} />
      </div>
    </Marquee>
  );
};
